import { Button, Group, Stack, Text } from '@mantine/core';
import { ModalV2 } from '@dealstack/frontend/shared/components/ModalV2/ModalV2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface Props {
	title: string;
	description: string;
	confirmLabel: string;
	isSubmitting?: boolean;
	onConfirm: () => void;
	onClose: () => void;
}

export const ScheduledQueueConfirmModal = ({
	title,
	description,
	confirmLabel,
	isSubmitting,
	onConfirm,
	onClose,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<ModalV2
			size="sm"
			onClose={onClose}
			reactModalProps={{ shouldCloseOnOverlayClick: !isSubmitting }}
		>
			<Stack gap="md">
				<Text fw={600} size="lg">
					{title}
				</Text>
				<Text size="sm" c="dark.0">
					{description}
				</Text>
				<Group justify="right" gap="xs">
					<Button variant="default" onClick={onClose} disabled={isSubmitting}>
						{tMipManage('automated_emails.scheduled_queue.confirm_modal.dismiss')}
					</Button>
					<Button onClick={onConfirm} loading={isSubmitting} disabled={isSubmitting}>
						{confirmLabel}
					</Button>
				</Group>
			</Stack>
		</ModalV2>
	);
};
